import {css} from 'lit';
export const styles = css`::slotted(ef-date-option) {
  padding: var(--options-padding);
  border-bottom: var(--options-border-bottom);
}
`;
export default styles;
